// store/reducer.ts

import {
    ADD_TO_CONTACTS,
    ADD_TO_FAVORITES,
    ProspectsActionTypes,
    ProspectsState,
    REMOVE_FROM_FAVORITES,
    REMOVE_FROM_SEQUENCE_CONTACTS,
    SET_CONTACT_TAGS,
    SET_FAVORITE_TAGS,
    SET_IS_LOADING,
    SET_SEARCH_FAILURE,
    SET_SEARCH_FILTERS,
    SET_SEARCH_LOADING,
    SET_SEARCH_RESULTS,
    SET_SEARCH_SUMMARY,
    SET_SEARCH_TOTAL,
    SET_SEQUENCE_CONTACTS,
    SET_SNACKBAR,
} from './types';

const initialState: ProspectsState = {
    searchResults: [],
    searchFilters: {
        platform: 'instagram',
        followerRange: {
            min: '0',
            max: 'Unlimited',
        },
        hashtags: [],
        lookalikes: [],
        gender: 'ANY',
        page: 0,
        sort: 'followers',
        dir: 'desc',
        tiktokShopFilters: {
            affiliateStatus: [],
        },
    },
    searchTotal: 0,
    searchError: '',
    searchLoading: false,
    favorites: [],
    contacts: [],
    sequenceContacts: [],
    contactTags: [],
    favoriteTags: [],
    isLoading: false,
    snackbar: { open: false, message: '' },
    searchSummary: {
        location: [],
        gender: 'any',
        followerRange: '0 - Unlimited',
        lookalikes: [],
        hashtags: [],
    },
};

export function prospectsReducer(
    state = initialState,
    action: ProspectsActionTypes,
): ProspectsState {
    switch (action.type) {
        case ADD_TO_FAVORITES:
            return {
                ...state,
                favorites: action.payload,
            };
        case REMOVE_FROM_FAVORITES:
            return {
                ...state,
                favorites: state.favorites.filter((id) => id !== action.payload),
            };

        case SET_SEARCH_RESULTS:
            return {
                ...state,
                searchResults: action.payload,
                searchLoading: action.loading,
            };
        case SET_SEARCH_FILTERS:
            return {
                ...state,
                searchFilters: action.payload,
            };
        case SET_SEARCH_TOTAL:
            return {
                ...state,
                searchTotal: action.payload,
            };
        case SET_SEARCH_FAILURE:
            return {
                ...state,
                searchError: action.payload,
                searchLoading: action.loading,
            };
        case SET_SEARCH_LOADING:
            return {
                ...state,
                searchLoading: action.loading,
            };
        case ADD_TO_CONTACTS:
            return {
                ...state,
                contacts: action.payload,
            };
        case SET_CONTACT_TAGS:
            return {
                ...state,
                contactTags: action.payload,
            };
        case SET_FAVORITE_TAGS:
            return {
                ...state,
                favoriteTags: action.payload,
            };
        case SET_IS_LOADING:
            return {
                ...state,
                isLoading: action.payload,
            };
        case SET_SNACKBAR:
            return {
                ...state,
                snackbar: action.payload,
            };
        case SET_SEARCH_SUMMARY: {
            return {
                ...state,
                searchSummary: action.payload,
            };
        }
        case SET_SEQUENCE_CONTACTS:
            return {
                ...state,
                sequenceContacts: action.payload,
            };
        case REMOVE_FROM_SEQUENCE_CONTACTS:
            return {
                ...state,
                sequenceContacts: state.sequenceContacts.filter((id) => id !== action.payload),
            };

        default:
            return state;
    }
}
